<template>
    <div class="col-sm-12 nopads">
        <div class="row px-3">
            <div class="data-list-item add col-sm-12" @click.stop="$emit('add')">
                <div class="item-img-cont add-title">
                    <i class="fa fa-plus" />
                </div>
                <div class="item-text-cont">
                    <span class="item-title-add">{{ $t('common.add_new') }}</span>
                    <font-awesome-icon icon="clipboard-check" class="card-body-icon" />
                </div>
            </div>
        </div>
        <Transition name="fade">
            <div v-if="inspectables.length > 0" class="col-sm-12 px-1 mt-3">
                <div class="col-sm-12 pb-2 list-content result-table">

                    <vue3-datatable
                        ref="resultTable"
                        :rows="inspectables"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="52em"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                        @row-click="emitEdit"
                    >
                        <template slot="empty">
                            <div class="text-center my-2">
                                {{ $t('area_report.no_results') }}
                            </div>
                        </template>
                    </vue3-datatable>
                </div>
                </div>
        </Transition>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'MvrInspectablesList',
    mixins: [restApi],
    components: {Vue3Datatable},
    props: {
        loadInspectables: {
            type: Boolean,
            default: false
        },
        defaultInspectables: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            loading: false,
            inspectables: [],
            fields: [
                {field: 'text', title: this.$t('inspectable_editor.name'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        defaultInspectables: {
            handler: function (val) {
                this.inspectables = val
            },
            deep: true
        }
    },
    mounted() {
        if(this.loadInspectables) {
            this.fetchInspectables()
        } else {
            this.inspectables = this.defaultInspectables
        }
    },
    methods: {
        fetchInspectables() {
            this.loading = true
            this.restFetch(this.mvrInspectableUrl, (response) => {
                this.inspectables = response.data
                this.loading = false
            })
        },
        emitEdit(inspectable) {
            this.$emit('edit', inspectable)
        }
    }
}
</script>
